import "./App.css";
import Title from "./Components/Title";
import CurrencyList from "./Components/CurrencyList";

const App = () => {
  return (
    <>
      <Title />
      <CurrencyList />
    </>
  );
};

export default App;
